
[...document.querySelectorAll('[data-dropdown-wrapper] [class="t4s-dropdown__content"] button, [id="Características"]+span')].forEach(data => {
    if(data.textContent.trim().search(/Featured/gi) > -1 || data.textContent.trim().search(/Featured/g) > -1) {
        data.innerHTML = "SORT";
    }
});



const arrayLinksWithCategoriasDisplay = 
[
  {url:"collections/new-in",categorie:"top-categorias-new-in"},
  {url:"collections/shirts-and-t-shirts",categorie:"top-categorias-camisas-camisetas"},
  {url:"collections/crop-tops",categorie:"top-categorias-crop-tops"},
  {url:"collections/jackets-and-hoodies",categorie:"top-categorias-buzos-chaquetas"},
  {url:"collections/jeans-pants-and-shorts",categorie:"top-categorias-jeans-pantalones"},
  {url:"collections/shorts-and-skirts",categorie:"top-categorias-faldas-shorts"},
  {url:"collections/dresses-for-women",categorie:"top-categorias-vestidos"},
  {url:"collections/accesories",categorie:"top-categorias-accesorios"},
  {url:"collections/moov-athleisure",categorie:"top-categorias-moov-atleisure"},
  {url:"collections/knit-clothes",categorie:"top-categorias-knit-pieces"},
  {url:"collections/swimwear",categorie:"top-categorias-swimwear"},
  {url:"collections/intimates",categorie:"top-categorias-intimates"},
];

document.addEventListener("DOMContentLoaded", function() {
  cargarMenus();

  
  setTimeout(() => {
        document.querySelector('#menu-mb__ul li a[href*="ropa-en-descuento-mujer"]').id = "sale-properties";
  }, "3000");

  let locationWindow = window.location.href.trim();
  locationWindow = locationWindow.replaceAll("https://onehalfshop.com","").trim();
  if(locationWindow.includes('?')) locationWindow = locationWindow.split('?')[0].trim();
  if(locationWindow.includes('/')) locationWindow = locationWindow.split('/')[1].trim();
  

  if(locationWindow != ""){
    document.querySelector('img[class*="header__normal-logo"]').src = "https://cdn.shopify.com/s/files/1/0654/9441/7646/files/Logo_negro_One_Half_0fed2ee7-9ab3-4075-b3cd-955563a99b17.png?v=1698274516";
    document.querySelector('img[class*="header__mobile-logo"]').src = "https://cdn.shopify.com/s/files/1/0654/9441/7646/files/Logo_negro_One_Half_0fed2ee7-9ab3-4075-b3cd-955563a99b17.png?v=1698274516";
    //document.querySelectorAll('.t4s-push-menu-btn, .t4s-site-nav__icons svg.t4s-icon').forEach(item => item.style.color = "#FED925");
  }

  let windowLocation = window.location.href.trim();
  windowLocation = windowLocation.replaceAll(/https:\/\/onehalfshop.com\/?/gi,'').split('?')[0].trim();
  console.log("|"+windowLocation+"|");
  if(windowLocation !== ""){
      let navigationHome = document.querySelector('[id="navigation-custom-home"]');
      if(navigationHome) navigationHome.style.display = "none";
      if(document.querySelector('[id="navigation-custom-home"] [class="scrollmenu"]')) document.querySelector('[id="navigation-custom-home"] [class="scrollmenu"]').scrollLeft += 30;
  }  
});


function cargarMenus() {
  arrayLinksWithCategoriasDisplay.forEach( data =>{
    const currentURL = window.location.href.trim();
    if(currentURL.indexOf(data.url)>-1){
      //if(document.querySelector("[id='"+data.categorie+"']")) document.querySelector("[id='"+data.categorie+"']").style.display = "";
    }
  });
}

//function nextItemSubMenuMobile(){
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(-10px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(-20px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(-30px, 0px, 0px)";
//}

//function previousItemSubMenuMobile(){
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(+"+(contador-20)+"px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(+"+(contador-10)+"px, 0px, 0px)";
//  document.querySelector('[id*="top-categorias"]:not([style*="display:none"]) [class="subcategorias-scrollmenu"]').style.transform = "translate3d(+"+(contador-5)+"px, 0px, 0px)";
//}



























